module.exports = __webpack_public_path__ + "static/img/qq.091cfec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq.png
// module id = rpJM
// module chunks = 1